import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import MainNavbar from "../components/layout/mainNavbar";
import Sidebar from "../components/layout/sidebar";
const PrivateRoute = ({ children, haveSidebar, roles }) => {
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/" /*state={{ from: location }}*/ />;
  }
  return (
    <>
      <MainNavbar haveSidebar={haveSidebar} />
      <div className={`w-100 ${haveSidebar ? "d-flex" : ""}`}>
        {haveSidebar ? <Sidebar /> : null}
        <div className={"w-100"}>{children}</div>
      </div>
    </>
  );
};

export default PrivateRoute;

// let location = useLocation();
// const user = useSelector((state) => state.login.userData);
//   const userHasRequiredRole = user && roles.includes(user.role) ? true : false;
//   if (isAuthenticated && !userHasRequiredRole) {
//     return <> NO ACCESS </>; // build your won access denied page (sth like 404)
//   }
//   https://dev.to/iamandrewluca/private-route-in-react-router-v6-lg5
// https://adarshaacharya.com.np/blog/role-based-auth-with-react-router-v6
